export const OBJECT_TYPE_ID = {
  realty: 1,
  land: 2,
};
export const OBJECT_TYPE_NAME = {
  [OBJECT_TYPE_ID.realty]: 'Недвижимость',
  [OBJECT_TYPE_ID.land]: 'Земля',
};
export default {
  // "Жилой дом	Недвижимое имущество"
  10: {
    sntsCode: '30100',
    objectTypeId: OBJECT_TYPE_ID.realty,
  },
  // "Квартира	Недвижимое имущество"
  20: {
    sntsCode: '30200',
    objectTypeId: OBJECT_TYPE_ID.realty,
  },
  // "Комната	Недвижимое имущество"
  30: {
    sntsCode: '30210',
    objectTypeId: OBJECT_TYPE_ID.realty,
  },
  // 'Доля в жилом доме, квартире, комнате	Недвижимое имущество'
  40: {
    sntsCode: '30700',
    objectTypeId: OBJECT_TYPE_ID.realty,
  },
  // Доля в земле  Земля
  41: {
    sntsCode: null,
    objectTypeId: OBJECT_TYPE_ID.land,
  },
  // 'Земельный участок, предоставленный для индивидуального жилищного строительства'  Земля
  50: {
    sntsCode: null,
    objectTypeId: OBJECT_TYPE_ID.land,
  },
  // 'Земельный участок, на котором расположен приобретенный жилой дом'  Земля
  60: {
    sntsCode: null,
    objectTypeId: OBJECT_TYPE_ID.land,
  },
  // 'Жилой дом с земельным участком'  Земля
  70: {
    sntsCode: null,
    objectTypeId: OBJECT_TYPE_ID.land,
  },
};
